<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="primary" size="60">
      </v-progress-circular>
    </div>

    <div v-else>
      <!-- map -->
      <!-- map -->
      <!-- map -->
      <div class="content">
        <div class="content-title">
          <l-map
            ref="map"
            style="width: 100vw; z-index: 0; height: 75vh"
            :style="`margin-top: calc(100px + ${insets.top}px)`"
            :zoom="zoom"
            :center="route.polyline[0]"
            :options="{
              zoomControl: false,
            }"
          >
            <l-tile-layer
              :url="url"
              :attribution="attribution"
              :detectRetina="true"
            ></l-tile-layer>

            <l-polyline
              v-if="route.path_category_id != 12 && route.id != 106"
              :lat-lngs="
                route.multi_day
                  ? JSON.parse(currentDay.polyline)
                  : route.polyline
              "
              color="var(--v-primary-base)"
              :dashArray="route.path_category_id == 4 ? '5, 10' : null"
            ></l-polyline>

            <l-control position="topleft">
              <div
                class="secondary rounded-pill px-2 d-flex align-center"
                @click="
                  $route.path.split('/')[1] == 'routes' ||
                  $route.path.split('/')[1] == 'favorites' ||
                  $route.path.split('/')[1] == 'achievements'
                    ? $router.go(-1)
                    : $router.push(`/islands/area/${currentArea.id}`)
                "
              >
                <v-btn icon>
                  <v-icon color="white">mdi-arrow-left-thin</v-icon>
                </v-btn>
                <span class="body-2 white--text pr-1">{{
                  $route.path.split("/")[1] == "routes"
                    ? $t("routes.title")
                    : $route.path.split("/")[1] == "favorites"
                    ? $t("menu.favorites")
                    : $route.path.split("/")[1] == "achievements"
                    ? $t("menu.achievements")
                    : currentArea.name
                }}</span>
              </div>
            </l-control>

            <l-control position="topright">
              <v-tooltip v-model="informationTooltip" left color="secondary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="pa-6 secondary rounded-circle mb-2"
                    :class="!start ? 'pulse-button-start' : ''"
                    @click="openDialog(null, 'start_route_dialog')"
                  >
                    <v-icon color="white" size="35">mdi-flag-triangle</v-icon>
                  </v-btn>
                </template>
                <span> {{ $t("routes.start_text") }} </span>
              </v-tooltip>

              <div class="d-flex flex-column align-center">
                <v-tooltip v-model="informationTooltip" left color="secondary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      class="secondary mb-2 white--text"
                      @click="getLocation"
                      :loading="locationLoader"
                    >
                      <v-icon color="white">mdi-crosshairs-gps</v-icon>
                    </v-btn>
                  </template>
                  <span>Τοποθεσία</span>
                </v-tooltip>
              </div>

              <div class="d-flex flex-column align-center">
                <v-btn
                  icon
                  class="secondary mb-2 white--text"
                  @click="informationTooltip = !informationTooltip"
                >
                  <v-icon color="white">mdi-information-outline</v-icon>
                </v-btn>

                <v-btn class="secondary mb-2" icon @click="onToggleFavorite">
                  <v-icon :color="favorite ? 'red' : 'white'">{{
                    favorite ? "mdi-heart" : "mdi-heart-outline"
                  }}</v-icon>
                </v-btn>

                <v-btn class="secondary" icon @click="onShare">
                  <v-icon color="white"> mdi-share</v-icon>
                </v-btn>

                <!-- <v-btn
                  class="secondary mt-2"
                  icon
                  v-if="isLoggedIn"
                  @click="onCheckPoint(currentPoi.poi.id)"
                >
                  <v-icon color="white"> mdi-check </v-icon>
                </v-btn> -->
              </div>
            </l-control>

            <div v-if="route.multi_day">
              <custom-marker
                v-for="(poi, i) in currentDay.pois"
                :key="i"
                :marker="{
                  lat: parseFloat(poi.poi.latitude),
                  lng: parseFloat(poi.poi.longitude),
                }"
              >
                <div
                  @click="
                    poi.poi.category_id != 21
                      ? openDialog(poi.poi, 'poi_dialog')
                      : ''
                  "
                  class="pin d-flex align-center justify-center"
                  :class="poi.poi.id == currentPoi.poi.id ? 'active' : ''"
                >
                  <v-icon
                    size="20"
                    color="white"
                    style="transform: rotate(-45deg)"
                    >{{ poiIcon(poi.poi) }}</v-icon
                  >
                </div>
              </custom-marker>
            </div>
            <div v-else>
              <custom-marker
                v-for="(poi, i) in route.path_pois"
                :key="i"
                :marker="{
                  lat: parseFloat(poi.poi.latitude),
                  lng: parseFloat(poi.poi.longitude),
                }"
              >
                <div
                  @click="
                    poi.poi.category_id != 21
                      ? openDialog(poi.poi, 'poi_dialog')
                      : ''
                  "
                  class="pin d-flex align-center justify-center"
                  :class="poi.poi.id == currentPoi.poi.id ? 'active' : ''"
                >
                  <v-icon
                    size="20"
                    color="white"
                    style="transform: rotate(-45deg)"
                    >{{ poiIcon(poi.poi) }}</v-icon
                  >
                </div>
              </custom-marker>
            </div>

            <custom-marker
              :marker="{ lat: location.latitude, lng: location.longitude }"
              v-if="hasLocation"
            >
              <v-icon
                color="secondary"
                class="rounded-circle pulse-button"
                size="15"
                >mdi-circle</v-icon
              >
            </custom-marker>
          </l-map>
        </div>
      </div>

      <!-- map -->
      <!-- map -->
      <!-- map -->

      <!-- Route details -->
      <!-- Route details -->
      <!-- Route details -->
      <!-- Route details -->

      <div
        class="page-body"
        :style="$route.path.split('/')[1] == 'routes' ? 'top:72%' : 'top: 72%'"
      >
        <div class="d-flex">
          <v-btn
            icon
            class="white rounded-0 px-6"
            @click="$vuetify.goTo(500, options)"
          >
            <v-icon class="px-2" color="primary darken-1" size="30"
              >mdi-chevron-up</v-icon
            >
          </v-btn>
          <div
            class="d-flex align-center white chevron-button px-2"
            v-if="route.multi_day"
          >
            <span
              class="primary--text text--darken-2"
              style="border-left: solid 1px #28aae5; width: 10px; height: 18px"
            ></span>
            <v-tooltip v-model="informationTooltip" top color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-item-group
                  v-model="window"
                  class="shrink d-flex"
                  mandatory
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-item
                    v-for="(day, i) in route.days"
                    :key="day.name + i"
                    v-slot="{ active, toggle }"
                  >
                    <div>
                      <v-btn
                        :input-value="active"
                        icon
                        @click="
                          toggle();
                          changeCurrentDay();
                        "
                        color="primary darken-1"
                      >
                        {{ i + 1 }}
                      </v-btn>
                    </div>
                  </v-item>
                </v-item-group>
              </template>
              <span>Επιλογή Hμέρας</span>
            </v-tooltip>
          </div>
        </div>

        <div class="d-flex flex-column px-4 py-2 white">
          <div class="d-flex align-center justify-space-between mb-2">
            <span
              class="primary--text text--darken-2 font-weight-regular text-h6"
            >
              {{
                route.multi_day
                  ? `${route.name} - ${$t("routes.day")} ${window + 1}`
                  : route.name
              }}
            </span>
            <div class="d-flex align-center">
              <v-btn
                v-if="!isLanguageSupported"
                icon
                class="warning-button"
                @click="instructionsDialog = true"
              >
                <v-icon color="white" class="warning rounded-circle" size="20">
                  mdi-alert-circle-outline
                </v-icon>
              </v-btn>

              <v-btn
                icon
                @click="play"
                :disabled="
                  !isLanguageSupported || currentPoi.poi.category_id == 21
                "
              >
                <v-icon
                  :class="
                    isLanguageSupported && currentPoi.poi.category_id != 21
                      ? 'primary '
                      : 'grey'
                  "
                  color="white"
                  class="primary rounded-circle"
                  size="20"
                >
                  mdi-play
                </v-icon>
              </v-btn>

              <v-btn icon @click="stop" :disabled="!playing">
                <v-icon
                  color="white"
                  class="rounded-circle"
                  size="20"
                  :class="playing ? 'primary' : 'grey'"
                >
                  mdi-stop
                </v-icon>
              </v-btn>
            </div>
          </div>
          <div
            v-if="route.multi_day"
            class="primary--text text--darken-2 d-flex"
          >
            <div class="mr-2">
              {{ getLevel(currentDay.level_id) }}
            </div>
            <div v-if="currentDay.length_chilometer != 0.0">
              {{ "- " + currentDay.length_chilometer + "km" }}
            </div>
          </div>
          <div v-else class="primary--text text--darken-2 d-flex">
            <div>
              {{ getLevel(route.level_id) }}
            </div>
            <div v-if="route.length_chilometer != 0.0">
              {{ "- " + route.length_chilometer + "km" }}
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- poi change -->
          <div class="d-flex align-center mb-4" v-if="currentPoi">
            <v-btn
              icon
              :disabled="
                route.multi_day
                  ? currentPoi == currentDay.pois[0]
                  : currentPoi == route.path_pois[0]
              "
              @click="previousPoi"
            >
              <v-icon color="primary " size="35">mdi-skip-previous</v-icon>
            </v-btn>

            <div
              class="d-flex align-center justify-center px-2"
              ref="startPageHeight"
            >
              <!-- <v-avatar size="60" class="mr-4">
                <img src="@/assets/avatar.jpg" alt="John" />
              </v-avatar> -->

              <span
                v-if="currentPoi"
                class="body-1 primary--text text--darken-2"
                @click="openDialog(currentPoi.poi, 'poi_dialog')"
                >{{
                  currentPoi.poi.name.includes("#")
                    ? currentPoi.poi.name.split("#")[0]
                    : currentPoi.poi.name
                }}
              </span>
            </div>

            <v-btn
              icon
              class="ml-auto"
              @click="nextPoi"
              :disabled="
                route.multi_day
                  ? currentPoi == currentDay.pois[currentDay.pois.length - 1]
                  : currentPoi == route.path_pois[route.path_pois.length - 1]
              "
            >
              <v-icon color="primary " size="35">mdi-skip-next</v-icon>
            </v-btn>
          </div>

          <v-divider class="mb-4"></v-divider>

          <span
            v-if="
              currentPoi && currentPoi.poi && currentPoi.poi.category_id != 21
            "
            class="body-2 mb-4 description"
            v-html="currentPoi.poi.description"
          >
          </span>

          <span>
            {{ currentPoi.poi.subtitle }}
          </span>

          <div class="d-flex flex-column align-self-start mb-4"></div>

          <div
            v-if="currentPoi.informations"
            class="d-flex flex-column align-self-start"
          >
            <div>Πληροφορίες</div>
            <div v-html="currentPoi.informations"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Route details -->
    <!-- Route details -->
    <!-- Route details -->
    <!-- Route details -->

    <v-dialog persistent v-model="sailingDialog" max-width="100%">
      <div
        class="pa-4 secondary text-center white--text d-flex align-center justify-center body-1"
        style="width: 100%; height: 150px"
        v-html="$t('general.sailingDialog')"
      ></div>
      <div class="secondary d-flex align-center justify-center pb-5">
        <v-btn color="white" @click="sailingDialog = false"> OK </v-btn>
      </div>
    </v-dialog>

    <v-dialog persistent v-model="cyclingDialog" max-width="100%">
      <div
        class="pa-4 secondary text-center white--text d-flex align-center justify-center body-1"
        style="width: 100%; min-height: 150px"
        v-html="$t('general.cyclingDialog')"
      ></div>
      <div class="secondary d-flex align-center justify-center pb-5">
        <v-btn color="white" @click="cyclingDialog = false"> OK </v-btn>
      </div>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialog.open"
      v-if="dialog.type == 'poi_dialog'"
      max-width="100%"
      fullscreen
    >
      <PoiDialog
        :ppoi="dialog.poi"
        v-if="dialog.open && dialog.type == 'poi_dialog'"
        @close="closeDialog"
      />
    </v-dialog>

    <v-dialog
      v-model="dialog.open"
      v-if="dialog.type == 'start_route_dialog'"
      max-width="100%"
    >
      <StartRouteDialog
        @getDirections="getDirections"
        @startRoute="startRoute"
        :start="start"
        v-if="dialog.open && dialog.type == 'start_route_dialog'"
        @close="closeDialog"
      />
    </v-dialog>

    <v-dialog v-model="instructionsDialog" fullscreen>
      <Instructions @close="instructionsDialog = false" />
    </v-dialog>

    <v-dialog v-model="achievementDialog" fullscreen>
      <AchievementDialog
        @close="achievementDialog = false"
        :route="route"
        :area-name="achievementAreaName"
        :day-number="route && route.multi_day ? window + 1 : null"
      />
    </v-dialog>

    <v-dialog v-model="locationAuthDialog" max-width="400">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{
            $t("routes.location_permission_required") ||
            "Location Permission Required"
          }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-icon color="warning" size="60" class="d-block mx-auto mb-4">
            mdi-map-marker-alert
          </v-icon>
          <p class="body-1 text-center">
            {{
              $t("routes.location_permission_message") ||
              "To start a route, you need to enable 'Always Allow' location access in your device settings. This allows the app to track your location and notify you when you reach points of interest, even when the app is in the background."
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="locationAuthDialog = false">
            {{ $t("general.close") || "Close" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { decodeEntities } from "@/utils/decodeEntities";
import Instructions from "@/components/Instructions.vue";

import AchievementDialog from "@/components/AchievementDialog.vue";

import StartRouteDialog from "@/components/StartRouteDialog.vue";

import PoiDialog from "@/components/PoiDialog.vue";

import L from "leaflet";
import { LMap, LTileLayer, LPolyline, LControl } from "vue2-leaflet";
import { Icon } from "leaflet";
import CustomMarker from "vue-leaflet-custom-marker";

import { LocalNotifications } from "@capacitor/local-notifications";
import { Share } from "@capacitor/share";

import BackgroundGeolocation from "cordova-background-geolocation-lt";
import { Haptics } from "@capacitor/haptics";
import { TextToSpeech } from "@capacitor-community/text-to-speech";
import { Network } from "@capacitor/network";
import { Filesystem, Directory } from "@capacitor/filesystem";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    PoiDialog,
    LMap,
    LTileLayer,
    LPolyline,
    LControl,
    CustomMarker,
    StartRouteDialog,
    Instructions,
    AchievementDialog,
  },

  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.map?.mapObject;
      // setTimeout(() => {
      //   this.$refs?.startPageHeight.scrollIntoView();
      // }, 2000);
    });
  },

  async created() {
    try {
      this.greenIcon = L.icon({
        iconUrl:
          "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      });
      this.status = await Network.getStatus();

      // Ensure areas are loaded when coming from Routes/Favorites/Achievements menu
      // so achievement dialog can resolve island name from route.area_id
      if (!this.$store.state.areas.areas?.length) {
        await this.$store.dispatch("getAreas");
      }

      this.loader = true;
      let route = null;
      if (!this.status.connected && this.$route.path.includes("saved-routes")) {
        route = await axios.get(`/savedRoute.json`);
      } else {
        route = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/paths/${this.$route.params.route_id}`,
        );
      }

      this.route = route.data.path;
      console.log(this.route, "hey I am the route");
      this.route.polyline = JSON.parse(this.route.polyline);
      this.setCurrentRoute(this.route);
      if (this.isFavorite) this.favorite = true;

      // console.log(this.route.path_pois);
      if (this.route && this.route.path_category_id == 4)
        this.sailingDialog = true;
      if (this.route && this.route.path_category_id == 9)
        this.cyclingDialog = true;
      if (this.route.multi_day) {
        this.currentDay = this.route.days[0];
        this.currentPoi = this.route.days[0].pois[0];
        this.route.polyline = JSON.parse(this.route.days[0].polyline);
      } else this.currentPoi = this.route.path_pois[0];
      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  async destroyed() {
    BackgroundGeolocation.removeGeofences().then((success) => {
      console.log("[removeGeofences] all geofences have been destroyed");
    });
    await TextToSpeech.stop();

    BackgroundGeolocation.stop();
  },

  watch: {
    async achievementDialog(open) {
      if (open && this.route?.area_id != null && !this.achievementAreaName) {
        try {
          const res = await axios.get(
            `${process.env.VUE_APP_BASE_URL}/areas/${this.route.area_id}`,
          );
          const name = res.data?.area?.name ?? res.data?.name ?? "";
          if (name) this.achievementAreaNameFetched = name;
        } catch (_) {}
      }
    },
  },

  data() {
    return {
      achievementAreaNameFetched: "",
      achievementDialog: false,
      favorite: false,
      playDescirption: false,
      instructionsDialog: false,
      window: 0,
      map: null,
      route: null,
      currentDay: null,
      currentPoi: null,
      loader: true,
      playing: false,
      start: false,
      locationLoader: false,
      status: false,
      informationTooltip: false,
      sailingDialog: false,
      cyclingDialog: false,
      greenIcon: null,
      triggeredPois: [],
      locationAuthStatus: null,
      locationAuthDialog: false,
      icon: L.icon({
        iconUrl: "/circle.svg",
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),

      marker: {
        lat: 0,
        lng: 0,
      },

      dialog: {
        open: false,
        poi: null,
        type: null,
      },

      options: {
        duration: 300,
        offset: 10,
        easing: "linear",
      },

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 10,
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,
      areas: (state) => state.areas.areas,
      location: (state) => state.base.location,
      mobileLang: (state) => state.base.mobileLang,
      isLanguageSupported: (state) => state.base.isLanguageSupported,
      insets: (state) => state.base.insets,
      favoriteRoutes: (state) => state.favorites.favoriteRoutes,
      user_id: (state) => state.auth.user_id,
      platform: (state) => state.base.platform,
      deviceIdentifier: (state) => state.base.deviceIdentifier,
    }),
    ...mapGetters(["isLoggedIn"]),

    hasLocation() {
      return !!location;
    },

    isFavorite() {
      let found = null;
      console.log(this.route, this.favoriteRoutes, "favoriteRoutes");
      if (this.route != null) {
        found = this.favoriteRoutes.find((route) => route.id === this.route.id);
        if (found) return true;
        else return false;
      } else return false;
    },

    achievementAreaName() {
      if (this.currentArea?.name) return this.currentArea.name;
      if (this.route?.area_id != null && this.areas?.length) {
        const area = this.areas.find((a) => a.id == this.route.area_id);
        if (area?.name) return area.name;
      }
      return this.achievementAreaNameFetched || "";
    },

    hasAlwaysLocationPermission() {
      if (this.locationAuthStatus === null) return true; // Allow on web/unknown platforms
      return (
        this.locationAuthStatus ===
        BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS
      );
    },
  },

  methods: {
    ...mapMutations(["setCurrentRoute"]),
    ...mapActions(["toggleFavorite"]),

    async checkLocationAuthorization() {
      try {
        const providerState = await BackgroundGeolocation.getProviderState();
        console.log("Provider state: ", providerState);
        console.log(
          "AUTHORIZATION_STATUS_ALWAYS: ",
          BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS,
        );
        this.locationAuthStatus = providerState.status;
      } catch (e) {
        console.log("Error checking location authorization: ", e);
        // Set to null if we can't check (e.g., on web)
        this.locationAuthStatus = null;
      }
    },

    getLevel(level_id) {
      if (level_id != null)
        switch (level_id) {
          case 1:
            return this.$t("levels.easy");
          case 2:
            return this.$t("levels.medium");
          case 3:
            return this.$t("levels.hard");
          default:
            break;
        }
    },

    async onCheckPoint(poi_id) {
      const res = await axios.post(
        `${process.env.VUE_APP_BASE_URL}/clients/achievement`,
        {
          client_id: this.user_id,
          path_id: this.route.id,
          poi_id,
        },
      );
      if (this.route.multi_day) {
        if (res.data.day_path_achieved) {
          this.achievementDialog = true;
        }
      } else if (!this.route.multi_day) {
        if (res.data.path_achieved) {
          this.achievementDialog = true;
        }
      }
    },

    async getBase64(url) {
      return axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) =>
          Buffer.from(response.data, "binary").toString("base64"),
        );
    },

    async onShare() {
      const b64image = await this.getBase64(
        "https://iguide.mobics.gr" + this.route.main_image,
      );

      //2.  save file in cache
      await Filesystem.writeFile({
        path: "https://iguide.mobics.gr" + this.route.main_image,
        data: b64image,
        directory: Directory.Cache,
        recursive: true,
      });

      //3. get full uri of the saved image
      let imgData = await Filesystem.getUri({
        path: "https://iguide.mobics.gr/" + this.route.main_image,
        directory: Directory.Cache,
      });

      await Share.share({
        title: this.route.name,
        text: this.route.name + "\n\n" + decodeEntities(this.route.description),
        url: "https://ionianislands.net/explore/",
        files: [imgData.uri],
        dialogTitle: `Share ${this.route.name}`,
      });
    },

    async onToggleFavorite() {
      if (!this.isLoggedIn) this.$router.push("/login");
      this.favorite = !this.favorite;
      await this.toggleFavorite({
        action: this.favorite ? "add" : "delete",
        type: "favourite_paths",
        id: this.route.id,
        route: this.route,
      });
    },
    poiIcon(poi) {
      switch (poi.category_id) {
        case 21:
          return "mdi-circle-outline";
        case 6:
          return "mdi-image-filter-hdr";
        case 8:
          return "mdi-castle";

        case 10:
          return "mdi-script";
        case 11:
          return "mdi-book-open-page-variant";
        case 12:
          return "mdi-forest";
        case 13:
          return "mdi-run";
        case 14:
          return "mdi-city";
        case 2:
          return "mdi-waves";
        case 7:
          return "mdi-church";
        case 18:
          return "mdi-bank";
        case 19:
          return "mdi-glass-wine";
        default:
          return "mdi-circle-outline";
      }
    },
    changeCurrentDay() {
      if (this.start) {
        BackgroundGeolocation.removeGeofences().then((success) => {
          console.log("[removeGeofences] all geofences have been destroyed");
        });
        this.start = false;
      }
      // Clear triggered POIs list when changing days
      this.triggeredPois = [];
      this.currentDay = this.route.days[this.window];
      this.currentPoi = this.currentDay.pois[0];
      const parsedPolyline = JSON.parse(this.currentDay.polyline);
      this.$refs.map.mapObject.setView(
        [parsedPolyline[0].lat, parsedPolyline[0].lng],
        10,
        {
          animate: true,
          duration: 0.6,
        },
      );
    },

    async getLocation() {
      try {
        this.locationLoader = true;
        await this.$store.dispatch("getLocation");
        this.locationLoader = false;

        this.setView(this.location);
      } catch (e) {
        console.log(e);
      }
    },

    async getDirections() {
      if (this.route.multi_day) {
        window.open(
          `https://www.google.com/maps/dir/?api=1&origin=${this.location.latitude}, ${this.location.longitude}&destination=${this.currentDay.pois[0].poi.latitude}, ${this.currentDay.pois[0].poi.longitude}&travelmode=driving`,
        );
      } else {
        window.open(
          `https://www.google.com/maps/dir/?api=1&origin=${this.location.latitude}, ${this.location.longitude}&destination=${this.route.path_pois[0].poi.latitude}, ${this.route.path_pois[0].poi.longitude}&travelmode=driving`,
        );
      }
    },

    async startRoute() {
      // Clear triggered POIs list when starting/restarting route
      this.triggeredPois = [];

      try {
        const state = await BackgroundGeolocation.ready({
          disableMotionActivityUpdates: true,
          desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,
          distanceFilter: 10,
          stopTimeout: 1,
          debug: false,
          logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
          stopOnTerminate: false,
          startOnBoot: true,
          geofenceModeHighAccuracy: true,
          geofenceProximityRadius: 100,
          locationAuthorizationRequest: "Always",
          locationAuthorizationAlert: {
            titleWhenNotEnabled: "Location-services not enabled",
            titleWhenOff: "Location-services OFF",
            instructions: "You must enable 'Always' in location-services.",
            cancelButton: "Cancel",
            settingsButton: "Settings",
          },
          backgroundPermissionRationale: {
            title: "Allow access to this device's location in the background?",
            message:
              "Explore Ionian Islands collects user's location data to enhance the user experience by comparing their location to predefined points of interest during an active 'route' in our app even when the app is minimized. To receive feedback as you approach points of interest while your app is minimized, please enable  the 'Allow all the time' permission",
            positiveAction: "Change to 'Allow all the time'",
          },

          notification: {
            title: "ionianislands",
            text: "Tracking is on",
            smallIcon: "mipmap/ic_launcher/ic_launcher",
            largeIcon: "mipmap/ic_launcher/ic_launcher",
          },
        });

        console.log("[BackgroundGeolocation] ready state: ", state);

        // Get the current provider/authorization state
        const providerState = await BackgroundGeolocation.getProviderState();
        console.log("[BackgroundGeolocation] provider state: ", providerState);
        console.log("[BackgroundGeolocation] status: ", providerState.status);
        console.log(
          "[BackgroundGeolocation] AUTHORIZATION_STATUS_ALWAYS: ",
          BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS,
        );

        // Check if we have at least foreground permission (status 3 = Always, status 4 = When In Use)
        // Status 4 is fine - the backgroundPermissionRationale will trigger on start()
        if (providerState.status < 3) {
          console.log(
            "[BackgroundGeolocation] Permission denied. Current status: ",
            providerState.status,
          );
          this.locationAuthDialog = true;
          return;
        }

        console.log("[BackgroundGeolocation] Starting location tracking...");
        await BackgroundGeolocation.start();

        // After start, check again if we got upgraded to "Always"
        const updatedProviderState =
          await BackgroundGeolocation.getProviderState();
        console.log(
          "[BackgroundGeolocation] Updated status after start: ",
          updatedProviderState.status,
        );

        if (
          updatedProviderState.status !==
          BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS
        ) {
          console.log(
            "[BackgroundGeolocation] Not upgraded to 'Always' yet. Showing info dialog.",
          );
          this.locationAuthDialog = true;
          return;
        }

        // Setup geofences only if permission is granted
        if (this.route.multi_day) {
          // Pre-mark helper POIs (category_id = 21) for logged-in users
          if (this.isLoggedIn) {
            for (let i = 0; i < this.currentDay.pois.length; i++) {
              if (this.currentDay.pois[i].poi.category_id === 21) {
                console.log(
                  `Pre-marking helper POI: ${this.currentDay.pois[i].poi.name}`,
                );
                await this.onCheckPoint(this.currentDay.pois[i].poi.id);
              }
            }
          }

          for (let i = 0; i < this.currentDay.pois.length; i++) {
            BackgroundGeolocation.addGeofence({
              identifier: this.currentDay.pois[i].poi.name,
              radius: 100,
              latitude: parseFloat(this.currentDay.pois[i].poi.latitude),
              longitude: parseFloat(this.currentDay.pois[i].poi.longitude),
              notifyOnEntry: true,
              notifyOnExit: true,
            })
              .then(async (success) => {})
              .catch((error) => {
                console.log("[addGeofence] FAILURE: ", error);
              });
          }

          try {
            await BackgroundGeolocation.onGeofence(async (geofenceEvent) => {
              if (geofenceEvent.action != "ENTER") return;

              const poi = this.currentDay.pois.find(
                (el) => el.poi.name == geofenceEvent.identifier,
              );

              if (poi == null) return;

              // Check if POI has already been triggered
              if (this.triggeredPois.includes(poi.poi.id)) {
                console.log(
                  `POI ${poi.poi.name} already triggered, skipping notification`,
                );
                return;
              }

              // Add to triggered list
              this.triggeredPois.push(poi.poi.id);

              // For category_id 21, only trigger checkpoint without notifications
              if (poi.poi.category_id == 21) {
                await this.setVisitedPoi(poi?.poi?.id, this.route.id);
                if (this.isLoggedIn) {
                  await this.onCheckPoint(poi.poi.id);
                }
                return;
              }

              await this.setVisitedPoi(poi?.poi?.id, this.route.id);
              await Haptics.vibrate();
              await LocalNotifications.schedule({
                notifications: [
                  {
                    title: `${poi.poi.name}`,
                    body: `${decodeEntities(poi.poi.description)}`,
                    id: 1,
                    schedule: { at: new Date(Date.now() + 100) },
                    attachments: null,
                    actionTypeId: "",
                    extra: null,
                  },
                ],
              });

              if (this.isLoggedIn) {
                await this.onCheckPoint(poi.poi.id);
              }
              this.openDialog(poi.poi, "poi_dialog");
            });
          } catch (e) {
            console.log(e);
          }

          this.start = true;
          if (this.route.multi_day) {
            this.currentPoi = this.currentDay.pois[0];
          } else {
            this.currentPoi = this.route.path_pois[0];
          }
          this.setView(this.currentPoi.poi);
        } else {
          // Pre-mark helper POIs (category_id = 21) for logged-in users
          if (this.isLoggedIn) {
            for (let i = 0; i < this.route.path_pois.length; i++) {
              if (this.route.path_pois[i].poi.category_id === 21) {
                console.log(
                  `Pre-marking helper POI: ${this.route.path_pois[i].poi.name}`,
                );
                await this.onCheckPoint(this.route.path_pois[i].poi.id);
              }
            }
          }

          for (let i = 0; i < this.route.path_pois.length; i++) {
            BackgroundGeolocation.addGeofence({
              identifier: this.route.path_pois[i].poi.name,
              radius: 100,
              latitude: parseFloat(this.route.path_pois[i].poi.latitude),
              longitude: parseFloat(this.route.path_pois[i].poi.longitude),
              notifyOnEntry: true,
              notifyOnExit: true,
            })
              .then(async (success) => {})
              .catch((error) => {
                console.log("[addGeofence] FAILURE: ", error);
              });
          }

          try {
            await BackgroundGeolocation.onGeofence(async (geofenceEvent) => {
              if (geofenceEvent.action != "ENTER") return;

              const poi = this.route.path_pois.find(
                (el) => el.poi.name == geofenceEvent.identifier,
              );

              if (poi == null) return;

              // Check if POI has already been triggered
              if (this.triggeredPois.includes(poi.poi.id)) {
                console.log(
                  `POI ${poi.poi.name} already triggered, skipping notification`,
                );
                return;
              }

              // Add to triggered list
              this.triggeredPois.push(poi.poi.id);

              // For category_id 21, only trigger checkpoint without notifications
              if (poi.poi.category_id == 21) {
                await this.setVisitedPoi(poi?.poi?.id, this.route.id);
                if (this.isLoggedIn) {
                  await this.onCheckPoint(poi.poi.id);
                }
                return;
              }

              await this.setVisitedPoi(poi?.poi?.id, this.route.id);
              await Haptics.vibrate();
              await LocalNotifications.schedule({
                notifications: [
                  {
                    title: `${poi.poi.name}`,
                    body: `${decodeEntities(poi.poi.description)}`,
                    id: 1,
                    schedule: { at: new Date(Date.now() + 100) },
                    attachments: null,
                    actionTypeId: "",
                    extra: null,
                  },
                ],
              });
              if (this.isLoggedIn) {
                await this.onCheckPoint(poi.poi.id);
              }
              this.openDialog(poi.poi, "poi_dialog");
            });
          } catch (e) {
            console.log(e);
          }

          this.start = true;
          if (this.route.multi_day) {
            this.currentPoi = this.currentDay.pois[0];
          } else {
            this.currentPoi = this.route.path_pois[0];
          }
          this.setView(this.currentPoi.poi);
        }
      } catch (error) {
        console.log("[BackgroundGeolocation] ready error: ", error);

        // Check authorization status on error
        await this.checkLocationAuthorization();

        // Show permission dialog if permission is not granted
        if (!this.hasAlwaysLocationPermission) {
          this.locationAuthDialog = true;
        }
        return;
      }
    },

    async setVisitedPoi(poi_id, path_id) {
      try {
        const payload = {
          visitor_status: this.isLoggedIn ? "logged_in" : "anonymous",
          poi_id,
          path_id,
          device_type: this.platform,
          device_id: this.deviceIdentifier,
        };
        if (this.isLoggedIn) {
          payload.user_id = this.user_id;
        }

        await axios.post(`${process.env.VUE_APP_BASE_URL}/visits`, payload);
      } catch (e) {
        console.log(e);
      }
    },

    async previousPoi() {
      await TextToSpeech.stop();

      if (this.route.multi_day) {
        const currentIndex = this.currentDay.pois.indexOf(this.currentPoi, 0);
        if (currentIndex - 1 >= 0) {
          this.currentPoi = this.currentDay.pois[currentIndex - 1];
          this.setView(this.currentPoi.poi);
        }
      } else {
        const currentIndex = this.route.path_pois.indexOf(this.currentPoi, 0);
        if (currentIndex - 1 >= 0) {
          this.currentPoi = this.route.path_pois[currentIndex - 1];
          this.setView(this.currentPoi.poi);
        }
      }
    },

    async nextPoi() {
      await TextToSpeech.stop();

      if (this.route.multi_day) {
        const currentIndex = this.currentDay.pois.indexOf(this.currentPoi, 0);
        if (currentIndex + 1 < this.currentDay.pois.length) {
          this.currentPoi = this.currentDay.pois[currentIndex + 1];
          this.setView(this.currentPoi.poi);
        }
      } else {
        const currentIndex = this.route.path_pois.indexOf(this.currentPoi, 0);
        if (currentIndex + 1 < this.route.path_pois.length) {
          this.currentPoi = this.route.path_pois[currentIndex + 1];
          this.setView(this.currentPoi.poi);
        }
      }
    },

    setView(coords) {
      this.$refs.map.mapObject.setView(
        [coords.latitude, coords.longitude],
        16,
        {
          animate: true,
          duration: 0.6,
        },
      );
    },

    async play() {
      try {
        this.playing = true;
        this.playDescirption = true;
        const decodedText = decodeEntities(this.currentPoi.poi.description);
        await TextToSpeech.speak({
          text: `${decodedText}`,
          lang: this.mobileLang.code,
          rate: 0.9,
          pitch: 1.0,
          volume: 1.0,
          category: "ambient",
        });
        this.playing = false;
      } catch (e) {
        console.log(e);
      }
    },

    async stop() {
      try {
        await TextToSpeech.stop();
        this.playing = false;
      } catch (e) {
        console.log(e);
      }
    },

    openDialog(poi, type) {
      this.dialog = {
        open: true,
        poi,
        type,
      };
    },

    closeDialog() {
      this.dialog = {
        open: false,
        poi: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chevron-button {
  border-top-right-radius: 10px !important;
}

.description {
  overflow-x: hidden;
  max-width: 100%;
  word-wrap: break-word;
}

.content {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.content-title {
  position: fixed;
  top: -10px;
  // left: 50%;
  // transform: translate(-50%, -50%);
  color: #fed136;
}

.page-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.view-more {
  width: 100% !important;
}

.pulse-button-start {
  -webkit-animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 var(--v-secondary-base);
}

.leaflet-marker-icon .pulse-button-start:hover {
  -webkit-animation: none;
}

@-webkit-keyframes pulse {
  0% {
  }
  70% {
    box-shadow: 0 0 0 15px rgba(90, 153, 212, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
}

.pulse-button {
  -webkit-animation: pulse-location 1.5s infinite;
  box-shadow: 0 0 0 8px rgba(#5a99d4, 0.5);
  border: 0.5px solid white;
}

.pulse-button:hover {
  -webkit-animation: none;
}

@-webkit-keyframes pulse-location {
  0% {
  }
  70% {
    // box-shadow: 0 0 0 8px rgba(90, 153, 212, 0);
  }
  100% {
    // box-shadow: 0 0 0 4px rgba(90, 153, 212, 0);
  }
}

.pin {
  width: 30px;
  height: 30px;
  background-color: #2980ca;
  border-radius: 60px 60px 0px 60px;
  position: relative;
  transform: rotate(45deg);
  margin-left: 5px;
  bottom: 20px;
}

.pin.active {
  background-color: #00518b;
}
</style>
